import React from "react";

const VariableProjects = ({ date, title, images, description, solutions }) => {
  return (
    <div className="project-page">
      <h2 className="project-date">PROJETOS › {date}</h2>
      <h1 className="project-title">{title}</h1>
      
      <div className="project-images">
        {images.map((image, index) => (
          <img key={index} src={image} alt={`Project image ${index + 1}`} className="project-image" />
        ))}
      </div>
      
      <div className="project-description">
        <h3>Atuações</h3>
        <p>{description}</p>
        <ul>
          {solutions.map((solution, index) => (
            <li key={index} className="project-solution">
              ✅ {solution}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VariableProjects;
